import styles from "./styles.module.scss";

export const H2 = (props) => {
  const {children} = props;

  return <h2 className={styles.h2}>{children}</h2>;
};
